module.exports = __webpack_public_path__ + "img/hy.01b126e.svg";